// ** React Imports
import { useRef } from "react";

// ** Third Party Components
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useTranslation } from "react-i18next";

// #####################################################

const REQUIRED_AGE = 18;

// #####################################################

const useValidateDate = ({ day, month, year, isDateSelected }) => {
	const dateError = useRef(false);
	const dateErrorMessage = useRef("");

	dayjs.extend(customParseFormat);

	const { t } = useTranslation("landing");

	const dateString = `${year}-${month}-${day}`;
	const result = dayjs(dateString, "YYYY-M-D", true);

	if (isDateSelected) {
		if (result.isValid()) {
			if (dayjs().diff(result, "year") >= REQUIRED_AGE) {
				dateError.current = false;
				dateErrorMessage.current = "";
			} else {
				dateError.current = true;
				dateErrorMessage.current = t("landing:register:dateErrorAge");
			}
		} else {
			dateError.current = true;
			dateErrorMessage.current = t("landing:register:dateError");
		}
	} else {
		dateError.current = false;
		dateErrorMessage.current = "";
	}

	// #####################################################

	return {
		dateError: dateError.current,
		dateErrorMessage: dateErrorMessage.current,
	};
};

// #####################################################

export default useValidateDate;

// #####################################################
